// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CustomCheckbox[data-v-7fbbcd56]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CustomCheckbox[data-v-7fbbcd56] .custom-control-label{margin:4px 0!important}.CustomCheckbox[data-v-7fbbcd56] .custom-control-label span{font-size:1.2rem}.CustomCheckbox[data-v-7fbbcd56].label_disabled .custom-control-label span{color:#999!important}", ""]);
// Exports
module.exports = exports;
